var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 26,
    viewBox: "0 0 42 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_31",
    "data-name": "Grupo 31",
    transform: "translate(-386 -611)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_25",
    "data-name": "Rect\\xE1ngulo 25",
    transform: "translate(386 611)",
    fill: "#fff",
    stroke: "#c7c7c7",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 26,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 25,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(310.834 514.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    d: "M435.83,119.71h-2.323l1.453-8.983h2.323Z",
    transform: "translate(-342.239 -5.516)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M572.147,105.43a5.724,5.724,0,0,0-2.083-.382c-2.294,0-3.909,1.223-3.919,2.972-.019,1.29,1.157,2.007,2.036,2.437.9.44,1.2.727,1.2,1.118-.009.6-.726.879-1.395.879a4.623,4.623,0,0,1-2.179-.478l-.306-.144-.325,2.017a7.069,7.069,0,0,0,2.591.478c2.437,0,4.024-1.2,4.043-3.068.009-1.023-.611-1.806-1.95-2.447-.812-.411-1.31-.688-1.31-1.109.01-.382.421-.774,1.338-.774a3.947,3.947,0,0,1,1.73.344l.21.1.316-1.94Z",
    transform: "translate(-470.135)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M794.116,116.528c.191-.516.927-2.513.927-2.513-.01.019.191-.526.306-.86l.162.774s.44,2.15.535,2.6Zm2.867-5.8h-1.8a1.146,1.146,0,0,0-1.214.745l-3.45,8.238h2.437l.488-1.348h2.982c.067.315.277,1.348.277,1.348h2.151l-1.874-8.983Z",
    transform: "translate(-689.017 -5.516)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M171.57,110.727l-2.275,6.126-.249-1.242a6.876,6.876,0,0,0-3.211-3.766l2.084,7.856h2.456l3.651-8.974Z",
    transform: "translate(-82.242 -5.516)",
    fill: "#00579f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M84.941,110.727H81.2l-.038.182a7.772,7.772,0,0,1,5.639,4.7l-.812-4.129a.961.961,0,0,0-1.051-.755Z",
    transform: "translate(0 -5.516)",
    fill: "#faa61a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.13df5360e4efabe1e2fa105c9608cd69.svg";
export { ForwardRef as ReactComponent };